import { Surface } from '@dapp/multi-lib/sdaoui/Surface';
import { Title1, Body2 } from 'components/Typography';
import Link from 'next/link';
import { Button } from '@dapp/multi-lib/sdaoui/Button';

export const VaultCardCreate = () => {
  return (
    <Surface
      rounded='medium'
      style='gradient'
      className='flex h-[425px] w-[291px] flex-col p-5 lg:p-6'
      outline='dash'
    >
      <div className='flex h-full flex-col items-center justify-center gap-6'>
        <Title1 className='text-[#9DB178]'>Create Custom Vault</Title1>
        <Body2 className='text-center'>
          Start creating your vaults and strategies
        </Body2>
        <Button component={Link} size='small' href={`/vaults/create`}>
          Create
        </Button>
      </div>
    </Surface>
  );
};
